import { dangerColor, successColor } from 'assets/jss/material-dashboard-pro-react';

const statusModal = (theme) => ({
	modalWrapper: {
		paddingBottom: '2rem',
		marginLeft: '2rem',
		marginRight: '2rem',
		textAlign: 'center',
		'& .dialogHeader': {
			paddingTop: '0px',
		},
	},
	modalBody: {
		margin: '0.8rem',
	},
	statusText: {
		margin: '.1rem 0 0 0.4rem',
		fontSize: 'medium',
	},
	refnumberText: {
		fontFamily: theme.fontFamily.albert.regular,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(22),
	},
	refNumber: {
		fontFamily: theme.fontFamily.albert.bold,
		fontStretch: 'normal',
		fontStyle: 'normal',
		letterSpacing: 'normal',
		fontSize: theme.fontSize(16),
		lineHeight: theme.fontSize(22),
	},
	refNumberWrapper: {
		display: 'flex',
		'justify-content': 'center',
		marginBottom: '20px',
	},
	iconWrapper: {
		display: 'block',
		textAlign: 'center',
		width: '100%'
	},
	successIcon: {
		color: successColor[0],
		height: '2em',
		width: '2em',
	},
	failureIcon: {
		color: dangerColor[7],
		height: '2em',
		width: '2em',
	},
});
export default statusModal;
